import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  Alert,
  AlertIcon,
	VStack,
} from '@chakra-ui/react';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { MdFace } from "react-icons/md";

import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import { useAcessoHook } from '../../../hooks/acessohook';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Inputs/Input';
import { AppError } from '../../../utils/AppError';

import {
  Container,
  Content,
  Header,
  FormView,
  ButtonsView,
  TabNameMail,
  TabRole,
  TabResumo,
} from './styles';

interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
  acesso: AcessoDATA;
  setAcessos: any;
  setPesqAcessos: any;
  handleAcessos: any;
}
interface AcessoDATA {
  id: number;
  email: string;
  nome: string;
  role: string;
  status: string;
  password?: string;
}
interface RoleDATA {
  id: number;
  role: string;
}

const ModalPerfilAcesso: React.FC<ModalPARAMS> = ({
  onClose = () => {},
  isVisible,
  acesso,
  setAcessos,
  setPesqAcessos,
  handleAcessos,
}) => {
  const handleOnClose = useCallback(() => {
    formRef.current?.reset();
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const formRef = useRef<FormHandles>(null);

  const { addToast } = useToast();
  const {
    acessoHook,
    setHookAcesso,
    setHookNameEmail,
    setHookPassword,
    setHookRole,
    resetHookAcesso,
  } = useAcessoHook();
  const [visible, setVisible] = useState(isVisible);

  const [tabIndex, setTabIndex] = useState(0);
	const [disableTab1, setDisableTab1] = useState(true);
	const [disableTab2, setDisableTab2] = useState(true);

  const [radioRole, setRadioRole] = useState('admin');
  const [messageVisible, setMessageVisible] = useState(false);
  const [message, setMessage] = useState('');

  const [senhaVisible, setSenhaVisible] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (acesso?.id) {
      setHookAcesso(acesso);
			setDisableTab1(false);
			setDisableTab2(false);
    }
  }, [acesso, setHookAcesso]);

	async function handleVerifAcesso(form: any) {
		try {
			if (!acesso.id) {
				const { data } = await api.post('portal/user/verif', { email: form.email });

				if (data.stat === 'E') {
					setMessage(data.mensagem);
					setMessageVisible(true);
				}

				if (data.stat === 'N') {
					await handleSubmitPrimeiro(form, data.stat);
					setMessage(data.mensagem);
					// setSenhaVisible(true);
				}
			}
			else {
				await handleSubmitPrimeiro(form, 'S');
			}
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível verificar o acesso.';

			addToast({
				type: 'error',
				title: 'Verificar Acesso!',
				description: msg,
			});
		}
	};

	async function handleSubmitPrimeiro (form: any, status: string) {
		try {
			formRef.current?.setErrors({});

			let schema;

			if (!senhaVisible) {
				schema = Yup.object().shape({
					nome: Yup.string().required('Nome é obrigatório'),
					email: Yup.string().required('E-mail é obrigatório'),
				});
			}
			else {
				schema = Yup.object().shape({
					nome: Yup.string().required('Nome é obrigatório'),
					email: Yup.string().required('E-mail é obrigatório'),
					password: Yup.string()
						.min(6, 'No minimo 6 dígitos')
						.required('Senha é obrogatória!'),
					confirmPassword: Yup.string()
						.when('password', {
							is: (val: string) => !!val.length,
							then: Yup.string().required('Campo obrigatório.'),
							otherwise: Yup.string(),
						})
						.oneOf([Yup.ref('password'), undefined], 'Senhas não conferem.'),
				});
			}

			await schema.validate(form, { abortEarly: false });

			setHookNameEmail(form.nome, form.email);

			if (status === 'N' && !senhaVisible) {
				setSenhaVisible(true);
				formRef.current?.getFieldRef('password').focus();
				return;
			}

			if (senhaVisible) {
				setHookPassword(form.password);
			}

			setDisableTab1(false);
			setDisableTab2(false);
			setTabIndex(1);
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRef.current?.setErrors(errors);
			}
		}
  };

	async function handleSubmit() {
		try {
			const { data } = await api.post('portal/user/store', acessoHook);

			setAcessos(data.acessos);
			setPesqAcessos(data.acessos);

			addToast({
				type: 'success',
				title: `${acesso.id ? 'Editar' : 'Cadastrar'} Acesso`,
				description: `O Acesso foi ${acesso.id ? 'editado' : 'cadastrado'} com sucesso!`,
			});
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : `Não foi possível ${acesso.id ? 'editar' : 'salvar novo'} acesso.`;

			addToast({
				type: 'error',
				title: `${acesso.id ? 'Editar' : 'Novo'} Acesso!`,
				description: msg,
			});
		}
		finally {
			handleOnClose();
		}
  };

	async function handleCancel() {
			resetHookAcesso();
			handleAcessos();
			handleOnClose();
			formRef.current?.reset();
	}

  return (
    <Container id="modalPerfilAcesso">
      <Content className={`${visible ? 'active' : ''}`}>
        <Tabs className="tabs" index={tabIndex}>
          <TabList className="tab-list">
            <Tab className="tab" onClick={() => setTabIndex(0)}>
              Passo 1
            </Tab>

            <Tab
							className="tab"
							isDisabled={disableTab1}
							onClick={() => {
								if (tabIndex === 0)
									if (!senhaVisible)
										handleVerifAcesso(formRef.current?.getData());
									else
										handleSubmitPrimeiro(formRef.current?.getData(), 'S');
								else
									setTabIndex(1);
							}}
						>
              Passo 2
            </Tab>

            <Tab
							className="tab"
							isDisabled={disableTab2}
							onClick={() => {
								if (tabIndex === 0)
									if (!senhaVisible)
										handleVerifAcesso(formRef.current?.getData());
									else
										handleSubmitPrimeiro(formRef.current?.getData(), 'S');
								else
									setTabIndex(2);
							}}
						>
              Passo 3
            </Tab>
          </TabList>

          <TabPanels className="tab-panels">
            <TabNameMail className="tab-panel" visibility={senhaVisible}>
              <Header>
                <h1>Criar Acesso</h1>
                <h2>Digite aos dados do usuário para criar o acesso.</h2>
              </Header>

              {messageVisible && (
                <Alert
                  status="error"
                  style={{
                    marginTop: '10px',
                    marginBottom: '10px',
                    borderRadius: '10px',
                  }}
                >
                  <AlertIcon />
                  {message}
                </Alert>
              )}

              <FormView
                id="form-nome-email"
                ref={formRef}
                initialData={acessoHook}
                onSubmit={handleVerifAcesso}
              >
                <div className="input">
                  <p>Nome <span>(obrigatório)</span></p>
                  <Input
                    name="nome"
                    type="text"
                    placeholder="Nome de usuário"
										icon={MdFace}
                  />
                </div>

                <div className="input">
                  <p>E-mail <span>(obrigatório)</span></p>
                  <Input
                    name="email"
                    type="email"
                    placeholder="Email de acesso"
										icon={FiMail}
                  />
                </div>

								<VStack id="inputs-password">
									<Alert status="info" mt={4} mb={-3} borderRadius={8}>
										<AlertIcon />
										{message}
									</Alert>

									<div className="input">
										<p>Senha <span>(obrigatório)</span></p>
										<Input
											name="password"
											type={showPassword ? "text" : "password"}
											placeholder="Senha"
											icon={FiLock}
											iconInputRight={{
												IconRight: showPassword ? FiEyeOff : FiEye,
												showPassword,
												setShowPassword
											}}
										/>
									</div>

									<div className="input">
										<p>Confirmar Senha <span>(obrigatório)</span></p>
										<Input
											name="confirmPassword"
											type={showConfirmPassword ? "text" : "password"}
											placeholder="Confirmar Senha"
											icon={FiLock}
											iconInputRight={{
												IconRight: showConfirmPassword ? FiEyeOff : FiEye,
												showPassword: showConfirmPassword,
												setShowPassword: setShowConfirmPassword
											}}
										/>
									</div>
								</VStack>

								<ButtonsView>
									<button
										className="btn-cancel"
										type="button"
										onClick={handleCancel}
									>
										Cancelar
									</button>

									<button className="btn-save" type="submit">
										Proximo
									</button>
								</ButtonsView>
              </FormView>
            </TabNameMail>

            <TabRole className="tab-panel">
              <Header>
                <h1>Perfis de Acesso</h1>
                <h2>
                  Selecione a opção, de acordo com o perfil que você quer que a
                  pessoa tenha.
                </h2>
              </Header>

              <div className="radio-group">
                <div className="radio">
                  <div
                    className="radio-label"
                    onClick={() => {
                      setRadioRole('admin');
                    }}
                  >
                    <input
                      type="radio"
                      value="admin"
                      checked={radioRole === 'admin'}
                      onChange={() => {
                        setRadioRole('admin');
                      }}
                    />
                    <label>Administrador</label>
                  </div>
                </div>

                <div className="radio">
                  <div
                    className="radio-label"
                    onClick={() => {
                      setRadioRole('caixa');
                    }}
                  >
                    <input
                      type="radio"
                      value="S"
                      checked={radioRole === 'caixa'}
                      onChange={() => {
                        setRadioRole('caixa');
                      }}
                    />
                    <label>Caixa</label>
                  </div>
                </div>
              </div>

              <ButtonsView>
                <button
                  className="btn-cancel"
                  type="button"
                  onClick={() => setTabIndex(0)}
                >
                  Voltar
                </button>
                <button
                  className="btn-save"
                  onClick={() => {
                    setHookRole(radioRole);
                    setTabIndex(2);
                  }}
                >
                  Proximo
                </button>
              </ButtonsView>
            </TabRole>

            <TabResumo className="tab-panel">
              <Header>
                <h1>Resumo</h1>
                <h2>Confirme as informações que você selecionou.</h2>
              </Header>

              <hr />

              <div className="item">
                <h1>Nome do usuário</h1>
                <h2>{acessoHook?.nome}</h2>
              </div>

              <div className="item">
                <h1>Email de acesso</h1>
                <h2>{acessoHook?.email}</h2>
              </div>

              <div className="item">
                <h1>Perfil</h1>
                <h2>
                  {acessoHook?.role === 'admin' ? 'Administrador' : 'Caixa'}
                </h2>
              </div>

              <ButtonsView>
                <button
                  className="btn-cancel"
                  type="button"
                  onClick={() => setTabIndex(1)}
                >
                  Voltar
                </button>
                <button className="btn-save" onClick={handleSubmit}>
                  Cadastrar
                </button>
              </ButtonsView>
            </TabResumo>
          </TabPanels>
        </Tabs>
      </Content>
    </Container>
  );
};

export default ModalPerfilAcesso;
